import { isEmpty } from "lodash";
import React from "react";

const InputContainer = ({ errors, details, onInputChange }) => {
  return (
    <div>
      <input
        name="code"
        type="number"
        value={details.code}
        className={`input-div ${!isEmpty(errors.code) ? "error" : ""}`}
        placeholder="Enter Code"
        onChange={(e) =>
          e.target.value.length < 7 &&
          onInputChange(e.target.value, e.target.name)
        }
      />
      {!isEmpty(errors.code) && (
        <span className="password-error">{errors.code}</span>
      )}
      <input
        name="password"
        type="password"
        className={`input-div ${!isEmpty(errors.password) ? "error" : ""}`}
        value={details.password}
        placeholder="New Password"
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
      />
      {!isEmpty(errors.password) && (
        <span className="password-error">{errors.password}</span>
      )}
      <input
        name="confirm_password"
        type="password"
        className={`input-div ${
          !isEmpty(errors.confirm_password) ? "error" : ""
        }`}
        value={details.confirm_password}
        placeholder="Confirm Password"
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
      />
      {!isEmpty(errors.confirm_password) && (
        <span className="password-error">{errors.confirm_password}</span>
      )}
    </div>
  );
};

export default InputContainer;
